export default (theme) => ({
  header: {
    position: 'fixed',
    background: theme.palette.background.white,
    zIndex: 1000,
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 90,
    width: '100%',
    padding: '20px 45px',
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    [theme.breakpoints.down('xl')]: {
      minHeight: 70,
      height: 70,
    },
    [theme.breakpoints.down('ml')]: {
      padding: 16,
    },
  },
  logoWrapper: {
    height: '100%',
    maxWidth: 320,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: 0,
    textDecoration: 'none',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      width: 'auto',
    },
  },
  logo: {
    width: 60,
    height: 'auto',
    maxHeight: 60,
    objectFit: 'contain',
    objectPosition: 'center',
    [theme.breakpoints.down('md')]: {
      width: 50,
      maxHeight: 50,
    },
    [theme.breakpoints.down('sm')]: {
      width: 40,
      maxHeight: 40,
    },
  },
  appTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: 'black',
    maxWidth: 400,
    width: '100%',
    marginLeft: 140,
    [theme.breakpoints.down('xl')]: {
      fontSize: 20,
      marginLeft: 135,
    },
    [theme.breakpoints.down('ml')]: {
      marginLeft: 115,
    },
    [theme.breakpoints.down('lg')]: {
      marginLeft: '16%',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  orgName: {
    fontSize: 20,
    fontWeight: 'bold',
    color: 'black',
    marginLeft: 20,
    maxHeight: 60,
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 2,
    wordBreak: 'break-word',
    overflow: 'hidden',
    [theme.breakpoints.down('ml')]: {
      marginLeft: 10,
      fontSize: 18,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  helperDiv: {
    width: 170,
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'inline-block',
      width: 130,
    },
    [theme.breakpoints.down('sm')]: {
      width: 95,
    },
  },
  langSelectorWrapper: {
    maxWidth: 320,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      width: 130,
    },
    [theme.breakpoints.down('sm')]: {
      width: 95,
    },
  },
});
